import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

/**
 * Search grid column to render currency values
 */
@Component({
    selector: "wbo-currency-column",
    templateUrl: "./currency-column.component.html",
    styleUrls: ["./currency-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => CurrencyColumnComponent), multi: true}
    ]
})
export class CurrencyColumnComponent extends AbstractColumnComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
